export const PATH = {
	partnerDeal: (skDealId: string) => `/partner_deals/${skDealId}`,
	partnerDealsNew: "/partner_deals/new"
} as const satisfies Record<string, string | ((...args: never[]) => string)>;

export const getSkFullPath = (path: string): string =>
	`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_SK}${path}`;
